import $ from "jquery";
import {
  GetGroup,
  modelForExport,
  pergolaConst,
  theModel,
  toggleLoad,
  getSubsystemSummary,
  getSideLabel,
  getDoorPanelInfo,
  getShutterInfo,
  getBlindInfo
} from "../../../core/3d-configurator";
import { createPDF } from "../../../core/customFunctions/createPDF";
import { state } from "../../../core/settings";
import "./summaryPage.scss";
import { loadFormData } from "./summary-page-portal/summaryPagePortal";
import {
  stringPostSize,
  stringRoofType,
  getLouvreTypes
} from "../../interface/interface";
import {
  stringNameFrameColor,
  stringNameRoofColor,
} from "../../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
export let countLeds = {
  count: 0,
};

function countVisibleObjectsByName(scene, name, exactMatch = false) {
  let count = 0;

  scene.traverse((object) => {
    if (!object.visible) return;

    const isMatch = exactMatch
      ? object.name === name
      : object.name.includes(name);

    if (isMatch) {
      count++;
    }
  });

  return count;
}

function countVisibleMeshes(model, nameGroup) {
  let visibleCount = 0;

  model.traverse((object) => {
    console.log(object.name);

    if (nameGroup === "fan" && object.name === nameGroup && object.visible) {
      visibleCount++;
    } else if (
      object.name &&
      object.name.includes(nameGroup) &&
      object.visible &&
      nameGroup !== "fan"
    ) {
      visibleCount++;
    }
  });

  return visibleCount;
}

function buildSideInfillHTML() {
  const doorSides = getSubsystemSummary(pergolaConst.systemType.slidingGlassDoor);
  const shutterSides = getSubsystemSummary(pergolaConst.systemType.privacyWall);
  const blindSides = getSubsystemSummary(pergolaConst.systemType.autoShade);

  let html = '';

  // Slidding Glass Doors
  if (doorSides.length > 0) {
    doorSides.forEach(side => {
      const info = getDoorPanelInfo(side);
      const label = getSideLabel(side);
      let dimensions = `${state.height * 100} x ${(Math.floor(info.panelWidth * 100)).toFixed(0)}`

      html += `
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_margin">Slidetec Glass Doors</h3>
        <div class="sum__page__main-list__info__param title_margin">${dimensions}</div>
      </div>
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_data">Color</h3>
        <div class="sum__page__main-list__info__param">${state.colorSladditec}</div>
      </div>
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_data">Quantity</h3>
        <div class="sum__page__main-list__info__param">${info.totalPanels}</div>
      </div>`;

    });
  } else {
    html += `
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_margin">Slidetec Glass Doors</h3>
        <div class="sum__page__main-list__info__param title_margin">No</div>
      </div>`;
  }

  // Shutters 
  if (shutterSides.length > 0) {
    shutterSides.forEach(side => {
      const info = getShutterInfo(side);
      const label = getSideLabel(side);
      let dimensions = `${state.height * 100} x ${(Math.floor(info.panelWidth * 100)).toFixed(0)}`

      html += `
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_margin">Aluminum Sliding Shutters</h3>
        <div class="sum__page__main-list__info__param title_margin">${dimensions}</div>
      </div>
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_data">Color</h3>
        <div class="sum__page__main-list__info__param">${state.colorShutters}</div>
      </div>
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_data">Quantity</h3>
        <div class="sum__page__main-list__info__param">${info.numPanels}</div>
      </div>`;
    });
  } else {
    html += `
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_margin">Aluminum Sliding Shutters</h3>
        <div class="sum__page__main-list__info__param title_margin">No</div>
      </div>`;
  }

  // --- Blinds ---
  if (blindSides.length > 0) {

    blindSides.forEach(side => {
      const info = getBlindInfo(side);
      const label = getSideLabel(side);
      let dimensions = `${state.height * 100} x ${(Math.floor(info.frameWidth * 100)).toFixed(0)}`
      html += `
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_margin">Outdoor Blinds</h3>
        <div class="sum__page__main-list__info__param title_margin">${dimensions}</div>
      </div>
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_data">Color</h3>
        <div class="sum__page__main-list__info__param">${state.colorZip}</div>
      </div>
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_data">Quantity</h3>
        <div class="sum__page__main-list__info__param">${info.numFrames}</div>
      </div>`;
    });
  } else {
    html += `
      <div class="sum__page__main-list__info"> 
        <h3 class="sum__page__main-list__info__title title_margin">Outdoor Blinds</h3>
        <div class="sum__page__main-list__info__param title_margin">No</div>
      </div>`;
  }

  return html;
}

export function summaryPageComponent(container, images = []) {
  const wall =
    [
      state.backWall && "Back Wall",
    ]
      .filter(Boolean)
      .join(", ") || "Freestanding";

  const roofType = stringRoofType[state.roofType];
  const louvreType = getLouvreTypes()[state.louvreType];
  const postSize = stringPostSize[state.postSize];
  const retractType = ((state.roofType === 1) && (state.retractOption === 'oneSide' ? "From One End Only" : "Meet in the Middle"));

  const frameColor = state.colorBody;
  const roofColor = state.colorRoof;
  const heaters = state.heaters ? `Yes` : "No";


  const colorZip = state.subSystem.has(pergolaConst.systemNameString.zip_shade)
    ? `${state.colorZip}`
    : "No";

  const transparency = state.subSystem.has(
    pergolaConst.systemNameString.zip_shade
  )
    ? `${state.transparency}%`
    : "No";
  const slidingGlassDoor = state.subSystem.has(
    pergolaConst.systemNameString.sliding_doors
  )
    ? `Yes`
    : "No";
  const slidingShutters = state.subSystem.has(
    pergolaConst.systemNameString.sliding_shutters
  )
    ? `Yes`
    : "No";

  const isTexture =
    typeof state.colorRoof === "string" &&
    /\.(jpe?g|png|webp)$/i.test(state.colorRoof);

  const style = isTexture
    ? `background-image: url('${state.colorRoof}'); background-size: cover; background-position: center;`
    : `background-color: ${state.colorRoof};`;

  const summaryContent = $(`
    <div id="summary-content">
  <div class="sum__page" id="sum-page">
    <h2 class="sum__page__title">Summary</h2>
    <p class="sum__page__main_description">All measurements, design and placement are approximate and subject for approval upon execution of order.</p>
    <div class="sum__page__close" id="sum-close"></div>

    <div id="js-summary-image-preview-1">
      <img class="sum__page__img" />
    </div>

    <ul class="sum__page__main-list">
     <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Set Up</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${wall}</div>
        </div>
      </li>

    <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Roof</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${roofType}</div>
        </div>

        ${state.roofType === 1 ? `<div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Retraction Style</h3>
          <div class="sum__page__main-list__info__param">${retractType}</div>
        </div>` : ``}

      </li>

    <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">LOUVRE</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${louvreType}</div>
        </div>
      </li>

    <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Roof Dimensions</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Louvre Span (m)</h3>
          <div class="sum__page__main-list__info__param">${state.length}</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Pivot (m)</h3>
          <div class="sum__page__main-list__info__param">${state.width}</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Height (m)</h3>
          <div class="sum__page__main-list__info__param">${state.height}</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Post size</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Size</h3>
          <div class="sum__page__main-list__info__param">${postSize}</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Roof Color</p>

        <div class="sum__page__main-list__info"> 
          <div class="sum__page__main-list__info__color" style="${style}"></div>
          <div class="sum__page__main-list__info__param">${state.colorRoof}</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Frame Color</p>

        <div class="sum__page__main-list__info"> 
          <div class="sum__page__main-list__info__color" style="background-color: ${state.colorBody
    }"></div>
          <div class="sum__page__main-list__info__param">${state.colorBody}</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
       <p class="sum__page__main-list__title">SIDE INFILL OPTIONS</p>
        ${buildSideInfillHTML()}
       </li>
   
       <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">HEATING | LIGHTING</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Perimeter LED lights</h3>
          <div class="sum__page__main-list__info__param">${state.electro.has(pergolaConst.optionNameString.LEDRampLight) ? "Yes" : "No"
    }</div>
        </div>

         <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Heater</h3>
          <div class="sum__page__main-list__info__param">${state.electro.has(pergolaConst.optionNameString.heater) ? "Yes" : "No"
    }</div>
        </div>
      </li>
    </ul>
  
    <div class="sum__page__buttons">
      <button class="sum__page__buttons__button sum__page__buttons__button--back" id="back-bt">BACK</button>
      <button class="sum__page__buttons__button sum__page__buttons__button--contact" id="contact-bt">Request quote</button>
       <button class="sum__page__buttons__button sum__page__buttons__button--contact" id="dw-bt">Download PDF</button>
    </div>
  </div> 
</div>
    `);

  const backButton = summaryContent.find("#back-bt");
  const contactButton = summaryContent.find("#contact-bt");
  const downloadButton = summaryContent.find("#dw-bt");

  summaryContent.find("#sum-close").on("click", () => {
    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
  });

  backButton.on("click", () => {
    toggleLoad(true);
    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
    toggleLoad(false);
  });

  contactButton.on("click", () => {
    window.location.href = "https://louvretec.co.nz/make-enquiry";
  });

  downloadButton.on("click", async () => {
    toggleLoad(true);

    if (!state.dayMode) {
      $("#switchButton-time").trigger("click");
      await createPDF("download");
      $("#switchButton-time").trigger("click");
    } else {
      await createPDF("download");
    }

    toggleLoad(false);

  });

  $(container).append(summaryContent);

  if (images[0]) {
    summaryContent.find("#js-summary-image-preview-1 img").attr("src", images[0].src);
  }
}
